<template>
    <div id="preloader" v-show="$store.state.isLoading"></div>
</template>